import {useEffect} from "react";

import {useInvalidate} from "@/src/modules/core/hooks";
import {useSetActiveShift} from "@/src/modules/shifts/store";

export function ShiftAutocompletedAlert() {
  const invalidateMe = useInvalidate("me");
  const invalidateActiveShift = useInvalidate("active-shift");
  const setActiveShift = useSetActiveShift();

  useEffect(() => {
    function handleShiftAutocompleted() {
      setActiveShift(null);
      invalidateMe();
      invalidateActiveShift();
    }

    window.addEventListener("shift:autocompleted", handleShiftAutocompleted);
    return () => {
      window.removeEventListener("shift:autocompleted", handleShiftAutocompleted);
    };
  }, []);

  return null;
}
